export default {"src":"/_next/static/media/mx-phone.ebad03a6.svg","height":81,"width":80,"blurWidth":0,"blurHeight":0};